import React from 'react';

export const ChevronDownSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "11"} height={height ?? "6"} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.54023 0.272266C1.19127 -0.0887256 0.625719 -0.0887251 0.264727 0.260233C0.0842314 0.440729 0 0.669357 0 0.910018C0 1.13865 0.0842314 1.36727 0.264727 1.53574L4.4402 5.73527C4.60866 5.90374 4.83729 6 5.07795 6C5.31861 6 5.54724 5.90374 5.7157 5.73527L9.89117 1.53574C10.2522 1.18678 10.2522 0.621225 9.89117 0.260233C9.54221 -0.0887251 8.96463 -0.0887256 8.61567 0.272266L5.07795 3.82202L1.54023 0.272266Z" fill={color ?? window?.settings?.secondary_color ?? "#04333B"} />
    </svg>
  )
}